import React, { useState, useEffect } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import cellEditFactory from 'react-bootstrap-table2-editor';
import SweetAlert from 'react-bootstrap-sweetalert';
import 'sweetalert/dist/sweetalert.css';
import {
  FormGroup,
  ModalBody,
  Col,
  Row,
  Button,
  Nav,
  NavItem,
  NavLink,
  Label,
  Input,
  TabContent,
  TabPane,
  Form,
  Modal,
  ModalHeader
} from 'reactstrap';
import NumberFormat from 'react-number-format'
import ReactSelect from "../../../components/Form/Select/Select"
import rotas from 'services/rotas';
import rest from 'lib/rest';
import Loading from 'lib/loading'
import useForm from '../../../lib/useForm';
import settings from './../../../settings';
import axios from 'axios'
import Switch from 'react-switch';
import FormModeloDesconto from "./FormModeloDesconto";
import FormImportModeloDesconto from "./FormImportModeloDesconto";
import useToggle from "lib/useToggle";

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const formSwal = withReactContent(Swal)

const FormCadastroConvenio = ({ closeModal, convenio_id }) => {

  const initialForm = {
    categ_sem_desc: "",
    conv_bairro: "",
    conv_bloqueio: "N",
    conv_cep: "",
    conv_cidade: "",
    conv_cnpj: "",
    conv_data_fechamento: "",
    conv_desconto: "",
    conv_dia_fechamento: "",
    conv_email: "",
    conv_endereco: "",
    conv_fax: "",
    conv_inscrestadual: "",
    conv_observacao: "",
    conv_telefone: "",
    conv_uf: "",
    conv_ufSelect: [],
    convenio: "",
    convenio_especial: "",
    convenio_id: "",
    convenio_me: "",
    desconto_parc: "",
    filial_id: "",
    integracao_id: "",
    old_convenio: "",
    old_convenio_id: "",
    status_transf: ""
  }

  const initialSweet = {
    show:false,
    title:'',
    text:'',
    type:'success'
  }

  const listaEstados = [
    { id: "AC", title: "Acre"},
    { id: "AL", title: "Alagoas"},
    { id: "AM", title: "Amazonas"},
    { id: "AP", title: "Amapá"},
    { id: "BA", title: "Bahia"},
    { id: "CA", title: "Ceará"},
    { id: "DF", title: "Distrito Federal"},
    { id: "ES", title: "Espírito Santo"},
    { id: "GO", title: "Goiás"},
    { id: "MA", title: "Maranhão"},
    { id: "MT", title: "Mato Grosso"},
    { id: "MS", title: "Mato Grosso do Sul"},
    { id: "MG", title: "Minas Gerais"},
    { id: "PA", title: "Pará"},
    { id: "PB", title: "Paraíba"},
    { id: "PR", title: "Paraná"},
    { id: "PE", title: "Pernambuco"},
    { id: "PI", title: "Piauí"},
    { id: "RJ", title: "Rio de Janeiro"},
    { id: "RN", title: "Rio Grande do Norte"},
    { id: "RO", title: "Rondônia"},
    { id: "RS", title: "Rio Grande do Sul"},
    { id: "RR", title: "Roraima"},
    { id: "SC", title: "Santa Catarina"},
    { id: "SE", title: "Sergipe"},
    { id: "SP", title: "São Paulo"},
    { id: "TO", title: "Tocantins"}
  ];

  const [form, onChange, setForm, onChangeSelect]     = useForm(initialForm)
  const [activeTab, setActiveTab]                     = useState('1')
  const [descontos, setDescontos]                     = useState([])
  const [loading, setLoading]                         = useState(true)
  const [sweetProps, setSweetProps]                   = useState(initialSweet)
  const [modalDesconto, setModalDesconto]             = useToggle(false)
  const [modalImportDesconto, setModalImportDesconto] = useToggle(false)

  const colunas = [
    {
      dataField: 'convenio_id',
      text: 'convenio',
      headerStyle: { cursor: 'default' },
      editable: false,
      hidden: true
    },
    {
      dataField: 'categoria_id',
      text: 'categoria',
      headerStyle: { cursor: 'default' },
      editable: false,
      hidden: true
    },
    {
      dataField: 'categoria',
      text: 'Categoria',
      align: 'left',
      headerStyle: { cursor: 'default', textAlign: 'left' },
      editable: false
    },
    {
      dataField: 'permite_venda',
      text: 'Permitir Vendas',
      align: 'left',
      headerStyle: { cursor: 'default', width: "20%" },
      editable:false,
      formatter: (cellContent, row) => {
          return (
            <Switch
              key={'switch'+row.categoria_id}
              className="react-switch"
              height={15}
              width={35}
              checked={row.permitir_venda}
              onChange={() =>
                toggleSelecionado(row)
              }
            />
          )
        }
    },
    {
      dataField: 'desconto',
      text: 'Desconto %',
      align: 'left',
      headerStyle: { cursor: 'default', width: "20%" }
    },
    {
      dataField: 'mark_up',
      text: 'Mark-up %',
      align: 'left',
      headerStyle: { cursor: 'default', width: "20%" }
    }
  ];

  useEffect(() => {
    const load = loading
    if (load === true) {
      if (convenio_id>0) {
        lstaConvenio(convenio_id)
      }else{
        setForm(initialForm)
        setLoading(false)
      }
    }
  }, []);

  useEffect(()=>{
    
  },[descontos])

  useEffect(()=>{
    if ((activeTab === '2') && (form.convenio_id === '')) {
      const propSweet = {
        show: true,
        title: 'Atenção',
        text: 'Convênio ainda não cadastrado!',
        type: 'error'
      }
      Swal.fire(propSweet.title,
        propSweet.text,
        propSweet.type
      )
      setActiveTab('1');
    }
  },[activeTab])

  const lstaConvenio = (convenio_id) => {

    const retorno = rest.get(rotas.convenios+convenio_id);
    retorno.then(ret => {
      if (ret != '' && ret.success && ret.success == 'S' && ret.lista!=''){

        const conv_uf       = listaEstados.filter((item) => item.id === ret.lista[0].conv_uf)
        ret.lista[0].conv_ufSelect= conv_uf[0]

        setForm(ret.lista[0])
        setDescontos(ret.descontos)
      }
      setLoading(false);
    })
  }

  const setSweet = () => {
    setSweetProps(initialSweet);
  }

  const editDescontoTabela = (oldValue, newValue, row, column) => {

    newValue = newValue.replace(',', '.');
    newValue = newValue.replace(/[^0-9.-]+/g,"")

    if(newValue===''){
      newValue=0;
    }

    newValue = parseFloat(newValue)

    if (column.dataField == 'desconto') {
      setDescontos((prevState) =>
        prevState.map((item) =>
          item.categoria_id === row.categoria_id
            ? {...item, desconto: newValue,  mark_up:0}
            : item
        )
      );
    }else{
      setDescontos((prevState) =>
        prevState.map((item) =>
          item.categoria_id === row.categoria_id
            ? {...item, mark_up: newValue, desconto:0}
            : item
        )
      );
    }
  }

  const onBlurTable = (oldValue, newValue, row, column) => {
    if(newValue===''){
      newValue=0;
    }

    const parametros={
      convenio_id : row.convenio_id,
      categoria_id : row.categoria_id,
      desconto : newValue
    }

    const url     = rotas.gravarDescontoConvenios;
    const retorno = rest.post(url, parametros);

    retorno.then(ret => {
      let title = '';
      let type = 'success';
      let tmpData = [] ;

      if(ret.success==='S'){
        title = 'Sucesso';
        type = 'success';

        lstaConvenio(convenio_id);
 
      }else{
        title = 'Erro'; 
        type = 'danger';
      }

      const propSweet = {
        show:true,
        title:title,
        text:ret.msg,
        type:type
      }

      setSweetProps(propSweet);
    })
  }

  const buscaCep = (e) => {
    let cep = e.target.value.replace(/\D/g, '')
    try{
      const retorno = axios.get("https://viacep.com.br/ws/"+ cep +"/json/")
      retorno.then(ret => {
        let local = ret.data
        setLoading(true)
        if (!("erro" in ret)) {
          let dados = form
          dados.conv_endereco = local.logradouro
          dados.conv_cidade   = local.localidade
          dados.conv_bairro   = local.bairro
          dados.conv_uf       = local.uf
          const conv_uf       = listaEstados.filter((item) => item.id === local.uf)
          dados.conv_ufSelect= conv_uf[0]
          setForm(dados)
        }
        setLoading(false)
      })
    }catch(err){
      console.log(err)
    }
  }

  const validIE = (e) => {
          
    let inscrEstatual = e.target.value

    const numero  = inscrEstatual.replace(/[^0-9]/g, '')
    const letra   = inscrEstatual.replace(/[^A-Za-z]/g, '')

    if (numero !== ''  || letra !== '') {
      if (numero !== '') {
        e.target.value      = numero
        form[e.target.name] = numero
        return true
      }

      if (letra !== '') {
        e.target.value      = 'ISENTO'
        form[e.target.name] = 'ISENTO'
      }
    }
  }

  const gravaConvenio = () => {
    const url = settings.url + rotas.gravarConvenios;
    
    let retorno = {};

    if(form.convenio_id>0){
      retorno = rest.post(url, form);
    }else{
      retorno = rest.put(url, form); 
    }

    retorno.then(ret => {
      let title = '';
      let type = 'success';

      if(ret.success==='S'){
        title = 'Sucesso';
        type = 'success';
      }else{
        title = 'Erro'; 
        type = 'danger';
      }
      const propSweet = {
        show:true,
        title:title,
        text:ret.msg,
        type:type
      }
      setSweetProps(propSweet);
    })
  }

  const toggleSelecionado = (row) => {
    setDescontos((prevState) =>
      prevState.map((item) =>
        item.categoria_id === row.categoria_id 
          ? {...item, permitir_venda: !item.permitir_venda }
          : item
      )
    );
  };

  //SUBMIT
  const handleSubmit = (evt) => {
    form.descontoConv = descontos
    
    evt.preventDefault()

    formSwal.queue([{
      title:                'Deseja salvar ?',
      confirmButtonText:    'Salvar',
      showCancelButton:     true,
      text:                 'Essas informações serão salvas no banco',
      showLoaderOnConfirm:  true,
      cancelButtonColor:    '#d33',
      preConfirm: () => {
        const url = rotas.gravarConvenios
        if(form.convenio_id > 0){
          return rest.post(url, form)
            .then(ret => {
              if ((ret.success) && (ret.success == 'S')) {
                lstaConvenio(convenio_id)
                formSwal.fire('Salvo!', ret.msg, 'success')
              }else{
                formSwal.fire('Erro!',ret.msg,'error')
              }
            })
        }else{
          return rest.put(url, form)
            .then(ret => {
              if ((ret.success) && (ret.success == 'S')) {
                lstaConvenio(ret.convenio_id)
                formSwal.fire('Salvo!',ret.msg,'success')
              }else{
                formSwal.fire('Erro!',ret.msg,'error')
              }
            })
        }
      }
    }])
  }

  if (loading) {
    return (
      <ModalBody className ="loadingBody">
        <Loading tipo='componente'/>
      </ModalBody>
    )
  } else {
    return (
      <FormGroup className="formCadastro">
        <SweetAlert
          show              = {sweetProps.show}
          type              = {sweetProps.type}
          style             = {{ display: "block", marginTop: "-100px" }}
          title             = {sweetProps.title}
          onConfirm         = {() => setSweet()}
          confirmBtnBsStyle = "info"
        >
         {sweetProps.text} 
        </SweetAlert>
        <ModalBody className="pb-0" >
          <Nav pills className="nav-pills-default justify-content-center mb-3" >
            <NavItem >
              <NavLink
                className = {activeTab == '1' ? 'active' : ''}
                onClick   = {() => setActiveTab('1')}
              >
                Dados Convênios
              </NavLink>
            </NavItem>

            <NavItem >
              <NavLink
                className = {activeTab == '2' ? 'active' : ''}
                onClick   = {() => setActiveTab('2')}
              >
                Descontos
              </NavLink>
            </NavItem>

            <NavItem >
              <NavLink
                className = {activeTab == '3' ? 'active' : ''}
                onClick   = {() => setActiveTab('3')}
              >
                Observação
              </NavLink>
            </NavItem>
          </Nav>

          <hr />

          <Form onSubmit={handleSubmit}>

          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
                <Row>
                  <Col md ='2'>
                    <FormGroup>
                      <Label for ="convenio_id">Código</Label>
                      <Input
                        disabled
                        id        = "convenio_id"
                        name      = "convenio_id"
                        maxLength = {50}
                        value     = {form.convenio_id}
                        onChange  = {onChange('convenio')}
                        style     = {{background: '#F9F9F9'}}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='10'>
                    <FormGroup>
                      <Label for="convenio">Convênio</Label>
                      <Input
                        id            = "convenio"
                        name          = "convenio"
                        maxLength     = {50}
                        onChange      = {onChange('convenio')}
                        defaultValue  = {form.convenio}
                      />
                    </FormGroup>
                  </Col>

                </Row>

                <Row>

                  <Col md='9'>
                    <FormGroup>
                      <Label for="conv_razao">Razão Social</Label>
                      <Input
                        id            = "conv_razao"
                        name          = "conv_razao"
                        maxLength     = {50}
                        onChange      = {onChange('conv_razao')}
                        defaultValue  = {form.conv_razao}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='3'>
                    <FormGroup>
                      <Label for="cnpj">CNPJ</Label>
                      <NumberFormat
                        id            = "cnpj"
                        name          = "cnpj"
                        type          = "text"
                        format        = {"##.###.###/####-##"}
                        className     = {"form-control"}
                        placeholder   = '00.000.000/0000-00'
                        onChange      = {onChange('conv_cnpj')}
                        defaultValue  = {form.conv_cnpj}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md='2'>
                    <FormGroup>
                      <Label for="cep">CEP</Label>
                      <NumberFormat
                        id            = "cep"
                        name          = "cep"
                        type          = "text"
                        mask          = "_"
                        format        = "#####-###"
                        className     = "form-control"
                        onChange      = {onChange('conv_cep')}
                        defaultValue  = {form.conv_cep}
                        onBlur        = {buscaCep}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='7'>
                    <FormGroup>
                      <Label for="endereco">Endereço</Label>
                      <Input
                        id            = "endereco"
                        name          = "endereco"
                        onChange      = {onChange('conv_endereco')}
                        defaultValue  = {form.conv_endereco}
                        maxLength     = {100}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='3'>
                    <FormGroup>
                      <Label for="ie">Inscrição Estadual</Label>
                      <Input
                        id            = "conv_inscrestadual"
                        name          = "conv_inscrestadual"
                        onChange      = {onChange('conv_inscrestadual')}
                        defaultValue  = {form.conv_inscrestadual}
                        maxLength     = {20}
                        onBlur        = {validIE}
                      />
                    </FormGroup>
                  </Col>  
                </Row>

                <Row>
                <Col md='5'>
                  <FormGroup>
                    <Label for="bairro">Bairro</Label>
                    <Input
                      id            = "bairro"
                      name          = "bairro"
                      onChange      = {onChange('conv_bairro')}
                      defaultValue  = {form.conv_bairro}
                      maxLength     = {100}
                    />
                  </FormGroup>
                </Col>

                <Col md='4'>
                  <FormGroup>
                    <Label for="bairro">Cidade</Label>
                    <Input
                      id            = "cidade"
                      name          = "cidade"
                      onChange      = {onChange('conv_cidade')}
                      defaultValue  = {form.conv_cidade}
                      maxLength     = {100}
                    />
                  </FormGroup>
                </Col>

                <Col md='3'>
                  <FormGroup>
                    <Label for="estado">Estado</Label>
                    <ReactSelect
                      id            = "estado"
                      name          = "estado"
                      placeholder   = "Selecione"
                      options       = {listaEstados}
                      defaultValue  = {form.conv_ufSelect}
                      onChange      = {onChangeSelect('conv_ufSelect')}
                      onClick       = {form.conv_ufSelect ? form.conv_uf = form.conv_ufSelect.id : ''}
                    />
                  </FormGroup>
                </Col>              
                </Row>

                <Row>
                  <Col md='6'>
                    <FormGroup>
                      <Label for="email">e-Mail</Label>
                      <Input
                        id            = "email"
                        name          = "email"
                        type          = "email"
                        placeholder   = "exemplo email@email.com.br"
                        onChange      = {onChange('conv_email')}
                        defaultValue  = {form.conv_email}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='3'>
                    <FormGroup>
                      <Label for="telefone">Telefone</Label>
                      <NumberFormat
                        id            = "telefone"
                        name          = "telefone"
                        mask          = "_"
                        format        = "(##) #### ####"
                        className     = "form-control"
                        placeholder   = "(00) 0000 0000"
                        onChange      = {onChange('conv_telefone')}
                        defaultValue  = {form.conv_telefone}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='3'>
                    <FormGroup>
                      <Label for="celular">Celular</Label>
                      <NumberFormat
                        id            = "celular"
                        name          = "celular"
                        mask          = "_"
                        format        = "(##) ##### ####"
                        className     = "form-control"
                        placeholder   = "(00) 00000 0000"
                        onChange      = {onChange('conv_fax')}
                        defaultValue  = {form.conv_fax}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row className="card-2 text-center">
                  <Col>
                    <span className="tag-card">Status do Convênio</span>
                    <FormGroup check inline className="mb-0">
                      <Label check>
                        <Input
                          type      = "checkbox"
                          id        = "bloqueado"
                          onChange  = {onChange('conv_bloqueio')}
                          checked   = {form.conv_bloqueio === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Bloqueado
                        </Label>
                    </FormGroup>{" "}

                    <FormGroup check inline className="mb-0">
                      <Label check>
                        <Input
                          type      = "checkbox"
                          id        = "permitir-preco-promocao"
                          onChange  = {onChange('convenio_especial')}
                          checked   = {form.convenio_especial === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Permitir Preço de Promoção
                        </Label>
                    </FormGroup>{" "}

                    <FormGroup check inline className="mb-0">
                      <Label check>
                        <Input
                          type      = "checkbox"
                          id        = "nao-aplicar-desconto-parcelamento"
                          onChange  = {onChange('desconto_parc')}
                          checked   = {form.desconto_parc === 'S' ? true : false}
                        />
                        <span className="form-check-sign" />Não Aplicar Desconto no Parcelamento
                        </Label>
                    </FormGroup>{" "}
                  </Col>
                </Row>
              
            </TabPane>
          </TabContent>

          <TabContent activeTab={activeTab}>
            <TabPane tabId="2">
                <ToolkitProvider
                  search
                  keyField  = "categoria_id"
                  data      = {descontos}
                  columns   = {colunas}
                >
                  {
                    props => (
                      <div>
                        <BootstrapTable
                          striped
                          keyField          = 'categoria_id'
                          data              = {descontos}
                          columns           = {colunas}
                          noDataIndication  = "Nenhum registro encontrado"
                          rowStyle          = {{ cursor: "pointer" }}
                          cellEdit          = {
                                                cellEditFactory({
                                                  mode: 'dbclick',
                                                  blurToSave: true,
                                                  beforeSaveCell: (oldValue, newValue, row, column) => { editDescontoTabela(oldValue, newValue, row, column) }
                                                })
                          }
                          {...props.baseProps}
                        />
                      </div>
                    )
                  }
                </ToolkitProvider>

                <Col className="text-right p-0">
                  <Button className="mb-0 mt-0" type="button" color="info" size="md" onClick={()=>{ setModalDesconto() }}  >Salvar modelo desconto</Button>
                  <Button className="mb-0 mt-0" type="button" color="warning" size="md" onClick={()=>{ setModalImportDesconto() }}  >Importar modelo desconto</Button>
                </Col>
                
            </TabPane>
          </TabContent>

          <TabContent activeTab={activeTab}>
            <TabPane tabId="3" >
                <FormGroup>
                  <Input
                    id            = "observacao"
                    name          = "observacao"
                    type          = "textarea"
                    placeholder   = "Digite aqui sua observação..."
                    maxLength     = {250}
                    className     = "form-control"
                    onChange      = {onChange('conv_observacao')}
                    defaultValue  = {form.conv_observacao}
                  />
                </FormGroup>
            </TabPane>
          </TabContent>

          <Col className="text-center p-3">
            <Button type="submit" className="mb-0 mt-0" color="success" size="md" >Salvar</Button>
            <Button className="mb-0 mt-0" color="default" size="md" onClick={closeModal}>Fechar</Button>
          </Col>
          </Form>
          
          <Modal
            key     = 'modalDesconto'
            size    = 'md'
            isOpen  = {modalDesconto}
          >
            <ModalHeader>Modelo Desconto de Convênio</ModalHeader>
            <FormModeloDesconto
              closeModal  = { setModalDesconto }
              descontos   = { descontos }
            >
            </FormModeloDesconto>
          </Modal>

          <Modal
            key     = 'modalImportDesconto'
            size    = 'md'
            isOpen  = {modalImportDesconto}
          >
            <ModalHeader>Importação do Modelo Desconto de Convênio</ModalHeader>
            <FormImportModeloDesconto
              closeModal    = { setModalImportDesconto }
              setDescontos  = {setDescontos}
            >
            </FormImportModeloDesconto>
          </Modal>
          
        </ModalBody>
      </FormGroup>
    )
  }
}

export default FormCadastroConvenio
